// Internal modules
import { logger } from '@/lib/logger';
import type { GenericObjectType } from '@/types';

const logCountryChange = (data: GenericObjectType) => {
  const { fromCountry, toCountry, transitionName, ...rest } = data;
  logger.fpti(transitionName, {
    billing_country: fromCountry,
    billing_country_changed: toCountry,
    state_name: 'change_country',
    transition_name: transitionName,
    ...rest,
  });
};

export const logCountryChangeAttemptToFPTI = (
  payload: GenericObjectType,
): void => {
  logCountryChange({ transitionName: 'prep_change_cntry', ...payload });
};

export const logCountryChangeSuccessToFPTI = (
  payload: GenericObjectType,
): void => {
  logCountryChange({
    transitionName: 'process_change_cntry',
    ...payload,
  });
};

export const logCountryChangeErrorToFPTI = (
  payload: GenericObjectType,
): void => {
  logCountryChange({
    transitionName: 'process_change_cntry_error',
    ...payload,
  });
};
